import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, Input, OnInit } from '@angular/core';
import { StorageService } from 'src/app/services/storage/storage.service';
import { CommonService } from 'src/app/services/common/common.service';
import * as ApexCharts from 'apexcharts';

@Component({
	selector: 'app-advisor-sales-dashboard',
	templateUrl: './advisor-sales-dashboard.component.html',
	styleUrls: ['./advisor-sales-dashboard.component.scss']
})
export class AdvisorSalesDashboardComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

  user_details: any;
  selected_business_plan: any = 0;
  // selected_duration: any = "ytd";
  selected_duration: any = "last 1 year";

  constructor(
    private storageService: StorageService,
    public commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.user_details = this.storageService.get('user_details');
    // this.getPageData();
    this.getProducts();
    // this.getBusinessPlan();
  }

  years_list: any = [];
  getYears() {
    let current_year = new Date().getFullYear();
    for (let index = 0; index < 10; index++) {
      this.years_list.push(current_year);
      current_year = current_year - 1;
    }
  }

  business_plan_list: any = [];
  getBusinessPlan() {
    const financial_institution = this.user_details.financial_institution;
    this.commonService.getData('/businessPlan?no_page=true&financial_institution=' + financial_institution).subscribe(
      (res: any) => {
        this.business_plan_list = res;
        // if (this.business_plan_list.length > 0) {
        //   this.selected_business_plan = this.business_plan_list[0].id;
        //   this.getPageData();
        // }
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  selected_products: any =  [];
  products_list: any = [];
  getProducts() {
    this.selected_products = [];
    this.commonService.getData('/product?no_page=true&business_area=' + this.user_details.role.business_area[0]).subscribe(
      (res: any) => {
        this.products_list = res;
        if (this.products_list.length > 0) {
          for (let index = 0; index < this.products_list.length; index++) {
            this.selected_products.push(this.products_list[index].id);
          }
        }
        this.getPageData();
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  @Input() advisor_id: any;

  page_loaded: boolean = false;
  page_data: any;
  getPageData() {
    this.page_loaded = false;
    // this.commonService.getData('/advisorperformance/' + this.selected_business_plan + '/?product=' +  this.selected_products,).subscribe(
    this.commonService.getData('/updatedadvisorperformance/?advisor=' + this.advisor_id + '&duration=' + this.selected_duration + '&product=' +  this.selected_products,).subscribe(
        (res: any) => {
          this.page_data = res;
          this.createPlannedActualGraphs();
          this.createDurationGraphs();
          this.createProductGraphs();
          this.createCustomerGraphs();

          this.createRegionGraphs();

          // setTimeout(() => {
          //   this.createSegmentGraph();
          // }, 200);

          this.page_loaded = true;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
          this.page_loaded = true;
        },
      );
  }

  createSegmentGraph() {
    let $this = this;
    var options = {
      colors: ['#1B82EC', '#FFA724', '#91C906'],
      series: this.page_data['quarterly_performance']['y-axis'],
      chart: {
        height: 350,
        type: 'line',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        curve: 'smooth',
        width: 3
      },
      fill: {
        type: 'solid',
        opacity: [0.2, 1],
      },
      labels: this.page_data['quarterly_performance']['x-axis'],
      markers: {
        size: 0,
      },
      yaxis: [
        {
          title: {
            text: '',
          },
          labels: {
            // formatter: function (value) {
            //   let val: string | number = Math.abs(value);
            //   if (val >= 10 ** 3 && val < 10 ** 6) {
            //     val = (val / 1000).toFixed(0) + 'K';
            //   } else if (val >= 10 ** 6) {
            //     val = (val / 1000000).toFixed(0) + 'M';
            //   } else {
            //     val = val;
            //   }
            //   return val;
            // },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
          },
        },
        // {
        //   opposite: true,
        //   title: {
        //     text: '',
        //   },
        // },
      ],
      // tooltip: {
      //   shared: true,
      //   intersect: false,
      //   y: {
      //     formatter: function (y) {
      //       if(typeof y !== "undefined") {
      //         return  y.toFixed(0) + " points";
      //       }
      //       return y;
      //     }
      //   }
      // }
    };
    var chart = new ApexCharts(
      document.querySelector('#performance-graph'),
      options,
    );
    chart.render();
  }

  show_planned_actual_graphs: boolean = true;
  createPlannedActualGraphs() {
    if (this.show_planned_actual_graphs == true) {
      setTimeout(() => {
        this.createPlannedActualGraph();
      }, 200);
    }
  }

  createPlannedActualGraph() {
    let $this = this;
    var options = {
      // colors: ["#D3D3D3", "#55A1EF"],
      colors: ['#1B82EC', '#FFA724', '#91C906'],
      series: $this.page_data['quarterly_performance_bar']['y-axis'],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('planned-actual-graph').clientWidth,
            $this.page_data['quarterly_performance_bar']['x-axis'].length,
            30,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['quarterly_performance_bar']['x-axis'],
        title: {
          // text: 'Quarters',
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Amount',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + val.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#planned-actual-graph'),
      options,
    );
    chart.render();
  }

  show_duration_graphs: boolean = true;
  createDurationGraphs() {
    if (this.show_duration_graphs == true) {
      setTimeout(() => {
        this.createMonthlySalesAmountGraph();
        if (this.selected_duration == 'ytd' || this.selected_duration == 'last 1 year') {
          this.createQuarterlySalesAmountGraph();
        }
        this.createYearlySalesAmountGraph();
      }, 200);
    }
  }

  createMonthlySalesAmountGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['monthly_performance_aum']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('monthly-sales-amount-graph').clientWidth,
            $this.page_data['monthly_performance_aum']['x-axis'].length,
            15,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['monthly_performance_aum']['x-axis'],
        title: {
          // text: 'Months'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Amount',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + val.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#monthly-sales-amount-graph'),
      options,
    );
    chart.render();
  }

  createQuarterlySalesAmountGraph() {
    // let $this = this;
    // var options = {
    //   colors: '#55A1EF',
    //   series: [
    //     {
    //       name: '',
    //       data: $this.page_data['quarterly_performance_aum']['y-axis'],
    //     },
    //   ],
    //   chart: {
    //     type: 'bar',
    //     toolbar: {
    //       show: false,
    //     },
    //     zoom: {
    //       enabled: false,
    //     },
    //     height: 300,
    //   },
    //   noData: {
    //     text: 'No Data Available',
    //     align: 'center',
    //     verticalAlign: 'middle',
    //     offsetX: 0,
    //     offsetY: 0,
    //     style: {
    //       color: '#006AFF',
    //       fontSize: '24px',
    //       fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
    //     },
    //   },
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       columnWidth: $this.commonService.getBarGraphPercentWidth(
    //         document.getElementById('quarterly-sales-amount-graph').clientWidth,
    //         $this.page_data['quarterly_performance_aum']['x-axis'].length,
    //         30,
    //       ),
    //       endingShape: 'rounded',
    //     },
    //   },
    //   dataLabels: {
    //     enabled: false,
    //   },
    //   stroke: {
    //     show: true,
    //     width: 2,
    //     colors: ['transparent'],
    //   },
    //   xaxis: {
    //     categories: $this.page_data['quarterly_performance_aum']['x-axis'],
    //     title: {
    //       // text: 'Quarters'
    //     },
    //     crosshairs: {
    //       show: false,
    //     },
    //   },
    //   yaxis: {
    //     title: {
    //       text: 'Count',
    //     },
    //     labels: {
    //       formatter: function (value) {
    //         let val: string | number = Math.abs(value);
    //         if (val >= 10 ** 3 && val < 10 ** 6) {
    //           val = (val / 1000).toFixed(0) + 'K';
    //         } else if (val >= 10 ** 6) {
    //           val = (val / 1000000).toFixed(0) + 'M';
    //         } else {
    //           val = val;
    //         }
    //         return val;
    //       },
          // formatter: (value: number) => {
          //   return this.commonService.labelFormatter(value);
          // }
    //     },
    //   },
    //   fill: {
    //     opacity: 1,
    //   },
    //   tooltip: {
    //     y: {
    //       formatter: function (val) {
    //         return val;
    //       },
    //     },
    //   },
    // };

    // var chart = new ApexCharts(
    //   document.querySelector('#quarterly-sales-amount-graph'),
    //   options,
    // );
    // chart.render();

    let $this = this;

		const options = {
			colors: $this.page_data["quarterly_performance_donut"]['colors'],
			series: $this.page_data["quarterly_performance_donut"]['data'],
			chart: {
				type: 'donut',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 350,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.page_data["quarterly_performance_donut"]['labels'],
			legend: {
				position: 'bottom',
				enabled: true,
				show: true,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
		};

		var chart = new ApexCharts(document.querySelector('#quarterly-sales-amount-graph'), options);
		chart.render();
  }

  createYearlySalesAmountGraph() {
    // let $this = this;
    // var options = {
    //   colors: '#55A1EF',
    //   series: [
    //     {
    //       name: '',
    //       data: $this.page_data['yearly_performance_aum']['y-axis'],
    //     },
    //   ],
    //   chart: {
    //     type: 'bar',
    //     toolbar: {
    //       show: false,
    //     },
    //     zoom: {
    //       enabled: false,
    //     },
    //     height: 300,
    //   },
    //   noData: {
    //     text: 'No Data Available',
    //     align: 'center',
    //     verticalAlign: 'middle',
    //     offsetX: 0,
    //     offsetY: 0,
    //     style: {
    //       color: '#006AFF',
    //       fontSize: '24px',
    //       fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
    //     },
    //   },
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       columnWidth: $this.commonService.getBarGraphPercentWidth(
    //         document.getElementById('yearly-sales-amount-graph').clientWidth,
    //         $this.page_data['yearly_performance_aum']['x-axis'].length,
    //         30,
    //       ),
    //       endingShape: 'rounded',
    //     },
    //   },
    //   dataLabels: {
    //     enabled: false,
    //   },
    //   stroke: {
    //     show: true,
    //     width: 2,
    //     colors: ['transparent'],
    //   },
    //   xaxis: {
    //     categories: $this.page_data['yearly_performance_aum']['x-axis'],
    //     title: {
    //       // text: 'Years'
    //     },
    //     crosshairs: {
    //       show: false,
    //     },
    //   },
    //   yaxis: {
    //     title: {
    //       text: 'Amount',
    //     },
    //     labels: {
    //       formatter: function (value) {
    //         let val: string | number = Math.abs(value);
    //         if (val >= 10 ** 3 && val < 10 ** 6) {
    //           val = (val / 1000).toFixed(0) + 'K';
    //         } else if (val >= 10 ** 6) {
    //           val = (val / 1000000).toFixed(0) + 'M';
    //         } else {
    //           val = val;
    //         }
    //         return val;
    //       },
    //     formatter: (value: number) => {
    //     return this.commonService.labelFormatter(value);
    // }
    //     },
    //   },
    //   fill: {
    //     opacity: 1,
    //   },
    //   tooltip: {
    //     y: {
    //       formatter: function (val) {
    //         return APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + val.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
    //       },
    //     },
    //   },
    // };

    // var chart = new ApexCharts(
    //   document.querySelector('#yearly-sales-amount-graph'),
    //   options,
    // );
    // chart.render();

    let $this = this;
    var options = {
      // colors: "#D3D3D3",
      series: [
        {
          name: '',
          data: $this.page_data['yearly_performance_aum']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('yearly-sales-amount-graph').clientWidth,
            $this.page_data['yearly_performance_aum'].length,
            20,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['yearly_performance_aum']['x-axis'],
        title: {
          text: '',
        },
        crosshairs: {
          show: false,
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      yaxis: {
        title: {
          text: '',
        },
        labels: {
          formatter: function (value) {
            return value;
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + val.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#yearly-sales-amount-graph'),
      options,
    );
    chart.render();
  }

  show_product_graphs: boolean = true;
  createProductGraphs() {
    if (this.show_product_graphs == true) {
      setTimeout(() => {
        this.createProductGroupGraph();
        this.createProductGraph();
        this.createProductTrendsGraph();
      }, 200);
    }
  }

  createProductGroupGraph() {
    // let $this = this;
    // var options = {
    //   colors: '#55A1EF',
    //   series: [
    //     {
    //       name: '',
    //       // data: $this.page_data["clients_by_productgroup"]["y-axis"]
    //       data: $this.page_data['clients_by_productgroup_chart']['y-axis'],
    //     },
    //   ],
    //   chart: {
    //     type: 'bar',
    //     toolbar: {
    //       show: false,
    //     },
    //     zoom: {
    //       enabled: false,
    //     },
    //     height: 300,
    //   },
    //   noData: {
    //     text: 'No Data Available',
    //     align: 'center',
    //     verticalAlign: 'middle',
    //     offsetX: 0,
    //     offsetY: 0,
    //     style: {
    //       color: '#006AFF',
    //       fontSize: '24px',
    //       fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
    //     },
    //   },
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       columnWidth: $this.commonService.getBarGraphPercentWidth(
    //         document.getElementById('product-group-graph').clientWidth,
    //         $this.page_data['clients_by_productgroup_chart']['x-axis'].length,
    //         30,
    //       ),
    //       endingShape: 'rounded',
    //     },
    //   },
    //   dataLabels: {
    //     enabled: false,
    //   },
    //   stroke: {
    //     show: true,
    //     width: 2,
    //     colors: ['transparent'],
    //   },
    //   xaxis: {
    //     // categories: $this.page_data["clients_by_productgroup"]["x-axis"],
    //     categories: $this.page_data['clients_by_productgroup_chart']['x-axis'],
    //     title: {
    //       // text: 'Years'
    //     },
    //     crosshairs: {
    //       show: false,
    //     },
    //   },
    //   yaxis: {
    //     title: {
    //       text: 'Count',
    //     },
    //     labels: {
    //       formatter: function (value) {
    //         let val: string | number = Math.abs(value);
    //         if (val >= 10 ** 3 && val < 10 ** 6) {
    //           val = (val / 1000).toFixed(0) + 'K';
    //         } else if (val >= 10 ** 6) {
    //           val = (val / 1000000).toFixed(0) + 'M';
    //         } else {
    //           val = val;
    //         }
    //         return val;
    //       },
          // formatter: (value: number) => {
          //   return this.commonService.labelFormatter(value);
          // }
    //     },
    //   },
    //   fill: {
    //     opacity: 1,
    //   },
    //   tooltip: {
    //     y: {
    //       formatter: function (val) {
    //         return val;
    //       },
    //     },
    //   },
    // };

    // var chart = new ApexCharts(
    //   document.querySelector('#product-group-graph'),
    //   options,
    // );
    // chart.render();

    let $this = this;

		const options = {
			colors: $this.page_data["clients_by_productgroup_donut"]['colors'],
			series: $this.page_data["clients_by_productgroup_donut"]['data'],
			chart: {
				type: 'donut',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 350,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.page_data["clients_by_productgroup_donut"]['labels'],
			legend: {
				position: 'bottom',
				enabled: true,
				show: true,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
		};

		var chart = new ApexCharts(document.querySelector('#product-group-graph'), options);
		chart.render();
  }

  createProductGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['clients_by_product']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('product-graph').clientWidth,
            $this.page_data['clients_by_product']['x-axis'].length,
            30,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_product']['x-axis'],
        title: {
          // text: 'Products'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#product-graph'),
      options,
    );
    chart.render();
  }

  createProductTrendsGraph() {
    let $this = this;
    var options = {
      colors: this.page_data['product_analysis_chart']['colors'],
      series: this.page_data['product_analysis_chart']['y-axis'],
      chart: {
        height: 300,
        type: 'line',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      fill: {
        type: 'solid',
        opacity: [0.2, 1],
      },
      labels: this.page_data['product_analysis_chart']['x-axis'],
      markers: {
        size: 0,
      },
      yaxis: [
        {
          title: {
            text: 'Count',
          },
          labels: {
            // formatter: function (value) {
            //   let val: string | number = Math.abs(value);
            //   if (val >= 10 ** 3 && val < 10 ** 6) {
            //     val = (val / 1000).toFixed(0) + 'K';
            //   } else if (val >= 10 ** 6) {
            //     val = (val / 1000000).toFixed(0) + 'M';
            //   } else {
            //     val = val;
            //   }
            //   return val;
            // },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
          },
        },
        // {
        //   opposite: true,
        //   title: {
        //     text: '',
        //   },
        // },
      ],
      // tooltip: {
      //   shared: true,
      //   intersect: false,
      //   y: {
      //     formatter: function (y) {
      //       if(typeof y !== "undefined") {
      //         return  y.toFixed(0) + " points";
      //       }
      //       return y;
      //     }
      //   }
      // }
    };
    var chart = new ApexCharts(
      document.querySelector('#product-trends-graph'),
      options,
    );
    chart.render();
  }

  show_customer_graphs: boolean = true;
  createCustomerGraphs() {
    if (this.show_customer_graphs == true) {
      setTimeout(() => {
        this.createFinancialSegmentGraph();
        this.createDemographicGroupGraph();
        this.createCustomerAUMGraph();
      }, 200);
    }
  }

  createFinancialSegmentGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['clients_by_segment']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_segment']['x-axis'],
        title: {
          // text: 'Segments'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#financial-segment-graph'),
      options,
    );
    chart.render();
  }

  createDemographicGroupGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['clients_by_demographicgroup']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_demographicgroup']['x-axis'],
        title: {
          // text: 'Demographic Group'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#demographic-group-graph'),
      options,
    );
    chart.render();
  }

  createCustomerAUMGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['clients_by_aum']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_aum']['x-axis'],
        title: {
          // text: 'AUM Range'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#customer-aum-graph'),
      options,
    );
    chart.render();
  }

  abbreviateNumber(value) {
    let fixed = 1;
    let num = value;
    if (num === null) {
      return null;
    }
    if (num === 0) {
      return '0';
    }
    fixed = !fixed || fixed < 0 ? 0 : fixed;
    var b = num.toPrecision(2).split('e'),
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
      c =
        k < 1
          ? num.toFixed(0 + fixed)
          : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
      d = c < 0 ? c : Math.abs(c),
      e = d + ['', 'K', 'M', 'B', 'T'][k];
    return e;

    // value = Math.round(value);
    // let new_value = value;
    // if (value >= 1000) {
    //     const suffixes = ["", "K", "M", "B","T"];
    //     const suffixNum = Math.floor( (""+value).length/3 );
    //     let shortValue: any = '';
    //     for (var precision = 2; precision >= 1; precision--) {
    //         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
    //         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
    //         if (dotLessShortValue.length <= 2) { break; }
    //     }
    //     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
    //     new_value = shortValue+suffixes[suffixNum];
    // }
    // return new_value;
  }

  show_region_graphs: boolean = true;
  createRegionGraphs() {
    if (this.show_region_graphs == true) {
      setTimeout(() => {
        this.createRegionSalesGraph();
        this.createRegionProductsGraph();
      }, 200);
    }
  }

  createRegionSalesGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['clients_by_region']['aum'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('region-sales-graph').clientWidth,
            $this.page_data['clients_by_region']['x-axis'].length,
            30,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_region']['x-axis'],
        title: {
          // text: 'Regions'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Amount',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 * 3 && val < 10 * 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          var aum = $this.page_data['clients_by_region']['aum'][dataPointIndex];
          var count =
            $this.page_data['clients_by_region']['y-axis'][dataPointIndex];

          return (
            'AUM: ' + APP_CONSTANTS.CURRENCY_SYMBOL + ' ' +
            aum.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
            '<br/> No. of Sales: ' +
            count
          );
        },
        // y: {
        //   formatter: function (val) {
        //     return APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + + val.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
        //   },
        // },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#region-sales-graph'),
      options,
    );
    chart.render();
  }

  createRegionProductsGraph() {
    let $this = this;

		var options = {
			colors: $this.page_data['region_product_chart']['colors'],
			series: $this.page_data['region_product_chart']['y-axis'],
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
				horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(document.getElementById('products-sales-graph').clientWidth, $this.page_data['region_product_chart']['x-axis'].length, 40),
					endingShape: 'rounded',
				},
			},
      dataLabels: {
        enabled: false,
      },
			xaxis: {
				categories: $this.page_data['region_product_chart']['x-axis'],
			},
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 * 3 && val < 10 * 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		var chart = new ApexCharts(document.querySelector('#products-sales-graph'), options);
		chart.render();
  }

}
